<template>
  <div>
    <!-- <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/goodsInfo' }">商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card> -->
    <!-- <el-card class="box-card">

    </el-card> -->
    <el-card>
      <div style="font-size: 16px; margin-bottom: 20px">
        {{ goodsItemIdData.name }}
      </div>
      <el-row :span="24">
        <el-col :span="24">
          <div v-if="goodsItemIdData.type == '专栏'">
            <el-button
              type="primary"
              @click="addGoodsList('录播')"
              icon="el-icon-plus"
              >添加录播</el-button
            >
            <el-button
              type="primary"
              @click="addGoodsList('题库')"
              icon="el-icon-plus"
              >添加题库</el-button
            >
            <el-button
              type="primary"
              @click="addGoodsList('实训')"
              icon="el-icon-plus"
              >添加实训</el-button
            >
            <el-button
              type="primary"
              @click="addGoodsList('直播')"
              icon="el-icon-plus"
              >添加直播</el-button
            >
          </div>
          <div v-else>
            <el-button
              type="primary"
              @click="addGoodsVideo"
              v-if="
                goodsItemIdData.type == '录播' ||
                goodsItemIdData.type == '套餐' ||
                goodsItemIdData.type == '面授' ||
                goodsItemIdData.type == '一元好课' ||
                goodsItemIdData.type == '提升技能' ||
                goodsItemIdData.type == '技巧速成攻略' ||
                goodsItemIdData.type == '学历考证' ||
                goodsItemIdData.type == '精品小课' ||
                goodsItemIdData.type == '免费课堂' ||
                goodsItemIdData.type == '系列课' ||
                goodsItemIdData.type == '免费课程'
              "
              icon="el-icon-plus"
              >添加录播</el-button
            >
            <el-button
              v-if="
                goodsItemIdData.type == '题库' ||
                goodsItemIdData.type == '套餐' ||
                goodsItemIdData.type == '面授' ||
                goodsItemIdData.type == '一元好课' ||
                goodsItemIdData.type == '提升技能' ||
                goodsItemIdData.type == '技巧速成攻略' ||
                goodsItemIdData.type == '学历考证' ||
                goodsItemIdData.type == '精品小课' ||
                goodsItemIdData.type == '免费课堂' ||
                goodsItemIdData.type == '系列课' ||
                goodsItemIdData.type == '免费课程'
              "
              type="primary"
              @click="addGoodsChapter('题库')"
              icon="el-icon-plus"
              >添加题库</el-button
            >
            <el-button
              v-if="goodsItemIdData.type == '实训'"
              type="primary"
              @click="addGoodsActualOperation"
              icon="el-icon-plus"
              >添加实训</el-button
            >
            <el-button
              v-if="goodsItemIdData.type == '面授'"
              type="primary"
              @click="addGoodsChapter('面授')"
              icon="el-icon-plus"
              >添加面授</el-button
            >
            <el-button
              v-if="
                goodsItemIdData.type == '直播' || goodsItemIdData.type == '套餐'
              "
              type="primary"
              @click="addLiveVideo(2)"
              icon="el-icon-plus"
              >添加小鹅通直播</el-button
            >

            <el-button
              v-if="
                goodsItemIdData.type == '直播' || goodsItemIdData.type == '套餐'
              "
              type="primary"
              @click="addLiveVideo(1)"
              icon="el-icon-plus"
              >添加民生直播
            </el-button>
            <el-button
              type="primary"
              @click="addMinShengTeachPlan()"
              v-if="
                goodsItemIdData.type == '录播' || goodsItemIdData.type == '套餐'
              "
              icon="el-icon-plus"
              >添加民生教学计划
            </el-button>
            <el-button
              v-if="
                goodsItemIdData.type == '录播' || goodsItemIdData.type == '套餐'
              "
              type="primary"
              @click="addBiGuo()"
              icon="el-icon-plus"
              >添加必过资源</el-button
            >
            <!-- <el-button
              v-if="
                goodsItemIdData.type == '一元好课' ||
                goodsItemIdData.type == '套餐'
              "
              type="primary"
              @click="addGoodsChapter('一元好课')"
              icon="el-icon-plus"
              >添加一元好课</el-button
            > -->
          </div>
        </el-col>
      </el-row>
      <div class="block" v-if="goodsItemIdData.type == '专栏'">
        <el-table
          :data="page.rows"
          style="width: 100%; margin-bottom: 20px; margin-top: 20px"
        >
          <el-table-column type="expand">
            <template slot-scope="{ row }">
              <el-table
                :data="row.goodsItemList"
                style="width: 100%; margin-bottom: 20px; margin-top: 20px"
                row-key="id"
                border
                default-expand-all
                :tree-props="{
                  children: 'children',
                  hasChildren: 'hasChildren',
                }"
              >
                <el-table-column label="所属课程">
                  <template slot-scope="{ row }">
                    {{ row.courseName }}
                  </template>
                </el-table-column>
                <el-table-column label="名称">
                  <template slot-scope="{ row }">
                    {{ row.name }}
                  </template>
                </el-table-column>
                <el-table-column label="类型">
                  <template slot-scope="{ row }">
                    <span>{{ row.type }}</span>
                    <div v-if="row.powerList" style="display: inline">
                      <span class="line"></span>
                      <el-popover trigger="click" v-model="row.isPrpover">
                        <el-checkbox-group v-model="checkList">
                          <el-checkbox
                            v-for="(item, index) in powerList"
                            :key="index"
                            :label="item.power"
                            >{{ item.name }}</el-checkbox
                          >
                        </el-checkbox-group>
                        <el-button
                          size="mini"
                          type="primary"
                          class="type-btn"
                          @click="sunmitType(row)"
                          >提交</el-button
                        >
                        <span slot="reference" @click="rangeCli(row)"
                          >范围<i class="el-icon-arrow-down el-icon--right"></i
                        ></span>
                      </el-popover>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="操作">
                  <template slot-scope="{ row }">
                    <span
                      v-if="row.type == '录播'"
                      style="margin-left: 30px"
                      class="mainColor"
                      @click="opConmon(row, 1)"
                      >查看</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="商品名">
            <template slot-scope="{ row }">
              {{ row.goodsInfoCenter.name }}
            </template>
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="{ row }">
              {{ row.goodsInfoCenter.type }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="{ row }">
              <el-popconfirm
                confirm-button-text="确定"
                cancel-button-text="取消"
                icon="el-icon-info"
                icon-color="red"
                @confirm="deleteGoodsItem(row.id)"
                @onCancel="deleteCancel"
                title="确定解绑吗？"
              >
                <el-button type="text" slot="reference">解绑</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else>
        <!-- 直播 -->
        <!--        <div v-if="goodsItemIdData.type == '直播'">-->
        <!--          <live-component @getData="pageList" :page="page" :id="goodsItemIdData.id" :hasLiveRoom="hasLiveRoom" :data="page.rows"></live-component>-->
        <!--        </div>-->
        <!-- <div v-if="goodsItemIdData.type == '直播'" style="width: 100%" class="draggable-tableaaa">
          <div style class="draggable-table">
            <div class="answer bor" style="width: 20%">直播名</div>
            <div class="answer bor" style="width: 40%">直播类型</div>
            <div class="answer bor" style="width: 10%">授课老师</div>
            <div class="delete bor" style="width: 10%">开始时间</div>
            <div class="answer bor" style="width: 10%">结束时间</div>
            <div class="delete bor" style="width: 10%">操作</div>
          </div>
          <draggable
            v-if="page.rows.length"
            v-model="page.rows"
            @update="datadragEnd"
            :options="{ animation: 500 }"
          >
            <div
              v-for="(element, index) in page.rows"
              :key="index"
              class="drag-item"
            >
              <div class="draggable-table">
                <el-tooltip
                  :open-delay="500"
                  class="item"
                  effect="dark"
                  :content="element.liveName"
                >
                  <div style="width: 20%" class="answer">
                    {{ element.liveName || "null" }}
                  </div>
                </el-tooltip>
                  <div v-if="element.liveType == 1" style="width: 40%" class="answer">
                    保利威
                  </div>
                  <div v-if="element.liveType == 2" style="width: 40%" class="answer">
                   小鹅通
                  </div>
                  <div v-if="element.liveType == 3" style="width: 40%" class="answer">
                    民生
                  </div>

                <div style="width: 10%" class="answer">
                  {{ element.liveTeacherName || "暂无" }}
                </div>
                <div style="width: 10%" class="answer">
                  {{ element.liveBeginTime || "暂无" }}
                </div>
                <div style="width: 10%" class="answer">
                  {{ element.liveEndTime || "暂无" }}
                </div>
                <div style="width: 10%" class="delete">
                  <i
                      slot="reference"
                      class="el-icon-delete mainColor"
                      title="解绑"
                      @click="deleteGoodsItem(element.id)"
                  ></i>
                  <el-popconfirm
                    confirm-button-text="确定"
                    cancel-button-text="取消"
                    icon="el-icon-info"
                    icon-color="red"
                    @confirm="deleteGoodsItem(element.id)"
                    @onCancel="deleteCancel"
                    title="确定解绑吗？"
                  >
                    <el-button type="text" slot="reference">解绑</el-button>
                  </el-popconfirm>
                <el-popconfirm
                    confirmButtonText="确定"
                    cancelButtonText="取消"
                    icon="el-icon-info"
                    iconColor="red"
                    @confirm="deleteGoodsItem(element.id)"
                    @cancel="deleteCancel"
                    title="确定解绑吗？"
                  >
                    <span slot="reference" class="mainColor">解绑</span>
                  </el-popconfirm>
                  <span
                    style="margin-left: 30px"
                    class="mainColor"
                    @click="editLive(element)"
                  >
                  编辑
                  </span>
                </div>
              </div>
            </div>
          </transition-group>
          </draggable>
          <div
            v-else
            style="
              text-align: center;
              line-height: 60px;
              color: #909399;
              border-bottom: 1px solid #ebeef5;
              border-right: 1px solid #ebeef5;
            "
          >
            暂无数据
          </div>
        </div> -->

        <div style="width: 100%" class="draggable-tableaaa">
          <div style class="draggable-table">
            <div class="answer bor" style="width: 20%">所属课程</div>
            <div class="answer bor" style="width: 40%">名称</div>
            <div class="answer bor" style="width: 10%">授课老师</div>
            <div class="delete bor" style="width: 10%">版本号/串流码</div>
            <div class="answer bor" style="width: 10%">类型</div>
            <div class="delete bor" style="width: 10%">操作</div>
          </div>
          <draggable
            v-if="page.rows.length"
            v-model="page.rows"
            @update="datadragEnd"
            :options="{ animation: 500 }"
          >
            <!-- <transition-group> -->
            <div
              v-for="(element, index) in page.rows"
              :key="index"
              class="drag-item"
            >
              <div class="draggable-table">
                <el-tooltip
                  :open-delay="500"
                  class="item"
                  effect="dark"
                  :content="element.courseName"
                >
                  <div style="width: 20%" class="answer">
                    {{ element.courseName || "暂无" }}
                  </div>
                </el-tooltip>
                <el-tooltip
                  :open-delay="500"
                  class="item"
                  effect="dark"
                  :content="element.name"
                >
                  <div style="width: 40%" class="answer">
                    {{ element.name || "暂无" }}
                  </div>
                </el-tooltip>
                <div style="width: 10%" class="answer">
                  {{ element.teacher || "暂无" }}
                </div>
                <div style="width: 10%" class="answer">
                  {{ element.version || "暂无" }}
                </div>
                <div style="width: 10%" class="answer">
                  <span v-if="element.type == '直播' && element.liveType == 1"
                    >保利威直播</span
                  >
                  <span
                    v-else-if="element.type == '直播' && element.liveType == 2"
                    >小鹅通直播</span
                  >
                  <span
                    v-else-if="element.type == '直播' && element.liveType == 3"
                    >民生直播</span
                  >
                  <span v-else>{{ element.type || "null" }}</span>

                  <div v-if="element.powerList" style="display: inline">
                    <span class="line"></span>
                    <el-popover trigger="click" v-model="element.isPrpover">
                      <el-checkbox-group v-model="checkList">
                        <el-checkbox
                          v-for="(item, index) in powerList"
                          :key="index"
                          :label="item.power"
                          >{{ item.name }}</el-checkbox
                        >
                      </el-checkbox-group>
                      <el-button
                        size="mini"
                        type="primary"
                        class="type-btn"
                        @click="sunmitType(element)"
                        >提交</el-button
                      >
                      <span slot="reference" @click="rangeCli(element)"
                        >范围<i class="el-icon-arrow-down el-icon--right"></i
                      ></span>
                    </el-popover>
                  </div>
                </div>
                <!-- </el-tooltip> -->

                <!-- <el-tooltip :open-delay="500" class="item" effect="dark" :content="String(index+1)">
                  <div
                    style="width:13.3%"
                    class="answer mainColor"
                    @click="opConmon(element,1)"
                  >{{element.videoCount||0}}</div>
                </el-tooltip> -->
                <div style="width: 10%" class="delete">
                  <!-- <i
                      slot="reference"
                      class="el-icon-delete mainColor"
                      title="解绑"
                      @click="deleteGoodsItem(element.id)"
                  ></i>-->
                  <el-popconfirm
                    confirm-button-text="确定"
                    cancel-button-text="取消"
                    icon="el-icon-info"
                    icon-color="red"
                    @confirm="deleteGoodsItem(element.id)"
                    @onCancel="deleteCancel"
                    title="确定解绑吗？"
                  >
                    <el-button type="text" slot="reference">解绑</el-button>
                  </el-popconfirm>
                  <!-- <el-popconfirm
                    confirmButtonText="确定"
                    cancelButtonText="取消"
                    icon="el-icon-info"
                    iconColor="red"
                    @confirm="deleteGoodsItem(element.id)"
                    @cancel="deleteCancel"
                    title="确定解绑吗？"
                  >
                    <span slot="reference" class="mainColor">解绑</span>
                  </el-popconfirm> -->
                  <span
                    v-if="element.type == '录播'"
                    style="margin-left: 30px"
                    class="mainColor"
                    @click="opConmon(element, 1)"
                    >查看</span
                  >
                </div>
              </div>
            </div>
            <!-- </transition-group> -->
          </draggable>
          <div
            v-else
            style="
              text-align: center;
              line-height: 60px;
              color: #909399;
              border-bottom: 1px solid #ebeef5;
              border-right: 1px solid #ebeef5;
            "
          >
            暂无数据
          </div>
        </div>
        <!-- <el-table
          ref="multipleTable"
          :data="page.rows"
          tooltip-effect="dark"
          style="margin-top: 20px; width: 100%;"
          border
          v-loading="loading"
        >
          <el-table-column show-overflow-tooltip prop="name" label="内容"></el-table-column>
          <el-table-column show-overflow-tooltip prop="type" label="类型"></el-table-column>
          <el-table-column show-overflow-tooltip prop="courseName" label="所属课程"></el-table-column>
          <el-table-column show-overflow-tooltip type="index" label="排序"></el-table-column>
          <el-table-column show-overflow-tooltip prop label="操作" width="80" align="center">
            <template slot-scope="scope">
              <div class="operationGroup">
                <i class="icon-shanchu mainColor" title="解绑" @click="deleteGoodsItem(scope.row.id)"></i>
              </div>
            </template>
          </el-table-column>
        </el-table>-->
        <el-pagination
          background
          @size-change="sizeChange"
          @current-change="currentChange"
          :page-sizes="[10, 50, 100, 200]"
          :current-page="page.pageNumber"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>
      </div>
    </el-card>

    <el-dialog
      title="添加录播"
      :visible.sync="addVideoVisible"
      width="800px"
      left
    >
      <el-form
        ref="searchForm"
        :model="videoSearchForm"
        :label-width="formLabelWidths"
      >
        <el-row>
          <el-col :sm="8" :md="8" :lg="8">
            <el-input
              v-model="videoSearchForm.name"
              placeholder="请输入视频课程名称"
              auto-complete="off"
            ></el-input>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="videocoursePageList"
              icon="el-icon-search"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="videocoursePage.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
        @selection-change="selectionChange"
      >
        <el-table-column
          show-overflow-tooltip
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="subjectCourseName"
          label="所属课程"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="name"
          label="视频课程名称"
        ></el-table-column>
        <el-table-column prop="teacher" label="授课老师"></el-table-column>
        <el-table-column prop="version" label="版本号"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="createTime"
          label="创建时间"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 50, 100, 200]"
        style="margin-top: 20px; text-align: right"
        :total="videocoursePage.total"
        :page-size="videocoursePage.pageSize"
        :current-page="videocoursePage.pageNumber"
        @size-change="videoSizeChange"
        @current-change="videoCurrentChange"
      ></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addVideoVisible = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch" type="primary">添 加</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="添加试卷"
      :visible.sync="addSubjectVisible"
      width="800px"
      left
    >
      <el-form
        ref="searchForm"
        :model="subjectForm"
        :label-width="formLabelWidth"
      >
        <el-row>
          <el-col :sm="8" :md="8" :lg="8">
            <el-form-item label="所属科目">
              <el-cascader
                :show-all-levels="false"
                ref="tree"
                @change="subjectChange"
                :options="subjectTreeList"
                :props="subjectTreeProps"
                collapse-tags
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="pageListExamType"
              icon="el-icon-search"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="subjectPage.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
        @selection-change="subjectSelectionChange"
      >
        <el-table-column
          show-overflow-tooltip
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="所属课程">
          <template slot-scope="row"
            >{{ row.row.ppname != null ? row.row.ppname + "-" : ""
            }}{{ row.row.pname != null ? row.row.pname + "-" : ""
            }}{{ row.row.name != null ? row.row.name : "" }}</template
          >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="examType"
          label="试卷类型"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="sizes,total, prev, pager, next"
        style="margin-top: 20px; text-align: right"
        :total="subjectPage.total"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="subjectPage.pageSize"
        :current-page="subjectPage.pageNumber"
        @size-change="subjectSizeChange"
        @current-change="subjectCurrentChange"
      ></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addSubjectVisible = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch" type="primary">添 加</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="预览视频"
      :visible.sync="videoDialog"
      @close="closeDialog"
      width="900px"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
    </el-dialog>
    <el-dialog
      :title="'添加' + chapterListType"
      :visible.sync="addChapterVisible"
      width="800px"
      left
    >
      <el-table
        ref="multipleTable"
        :data="chapterPage.rows"
        tooltip-effect="dark"
        style="width: 100%"
        border
        @selection-change="chapterSelectionChange"
      >
        <el-table-column
          show-overflow-tooltip
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="所属课程">
          <template slot-scope="row"
            >{{ row.row.ppname != null ? row.row.ppname + "-" : ""
            }}{{ row.row.pname != null ? row.row.pname + "-" : ""
            }}{{ row.row.name != null ? row.row.name : "" }}</template
          >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="name"
          label="课程名称"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 50, 100, 200]"
        style="margin-top: 20px; text-align: right"
        :total="chapterPage.total"
        :page-size="chapterPage.pageSize"
        :current-page="chapterPage.pageNumber"
        @size-change="chapterSizeChange"
        @current-change="chapterCurrentChange"
      ></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addChapterVisible = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch" type="primary">添 加</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="添加实训"
      :visible.sync="addActualOperationVisible"
      width="800px"
      left
    >
      <el-table
        ref="multipleTable"
        :data="actualOperationPage.rows"
        tooltip-effect="dark"
        style="margin-top: -30px; width: 100%"
        border
        @selection-change="actualOperationChange"
      >
        <el-table-column
          show-overflow-tooltip
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="cid"
          label="cid"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="cname"
          label="课程名称"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 50, 100, 200]"
        style="margin-top: 20px; text-align: right"
        :total="actualOperationPage.total"
        :page-size="actualOperationPage.pageSize"
        :current-page="actualOperationPage.pageNumber"
        @size-change="actualOperationSizeChange"
        @current-change="actualOperationCurrentChange"
      ></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addActualOperationVisible = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch" type="primary">添 加</el-button>
      </div>
    </el-dialog>

    <el-dialog title="绑定视频" :visible.sync="bindVisible" width="80%" left>
      <el-table
        v-show="showState == 1"
        :data="page1.rows"
        style="width: 100%; margin-bottom: 20px; margin-top: 20px"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
              :data="props.row.videoInfoList"
              style="width: 100%; margin-bottom: 20px; margin-top: 20px"
              border
            >
              <el-table-column type="selection" width="40"></el-table-column>
              <el-table-column
                prop="videoCourseName"
                label="具体课程"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="视频名称"
                :show-overflow-tooltip="true"
              ></el-table-column>

              <el-table-column
                prop="tryUse"
                label="试看"
                align="center"
                width="100"
              >
                <template slot-scope="row">
                  <span v-if="row.row.tryUse == '1'" class="mainColor">是</span>
                  <span v-else class="mainColor">否</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="playCount"
                label="次数"
                align="center"
                width="100"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="url"
                label="播放"
                width="100"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <i
                    class="el-icon-caret-right"
                    style="font-size: 20px; color: #409eff"
                    @click="
                      playerOptions.sources[0].src = scope.row.url;
                      videoDialog = true;
                    "
                  ></i>
                </template>
              </el-table-column>
              <el-table-column
                prop="duration"
                align="center"
                width="100"
                label="时长"
              ></el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="分组名称" prop="name"> </el-table-column>
      </el-table>
      <el-table
        v-show="showState == 0"
        ref="multipleTables"
        :data="page1.rows"
        tooltip-effect="dark"
        style="width: 100%"
        border
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="sort" label="排序" width="55"></el-table-column>
        <el-table-column
          prop="videoCourseName"
          label="具体课程"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="视频名称"
          :show-overflow-tooltip="true"
        ></el-table-column>

        <el-table-column prop="tryUse" label="试看" align="center" width="100">
          <template slot-scope="row">
            <span v-if="row.row.tryUse == '1'" class="mainColor">是</span>
            <span v-else class="mainColor">否</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="playCount"
          label="次数"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="url"
          label="播放"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <i
              class="el-icon-caret-right"
              style="font-size: 20px; color: #409eff"
              @click="
                playerOptions.sources[0].src = scope.row.url;
                videoDialog = true;
              "
            ></i>
          </template>
        </el-table-column>
        <el-table-column
          prop="duration"
          align="center"
          width="100"
          label="时长"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        style="margin-top: 20px; text-align: right"
        :total="page1.total"
        :page-sizes="[10, 50, 100, 200]"
        :small="true"
        :page-size="page1.pageSize"
        :current-page="page1.pageNumber"
        @size-change="sizeChange1"
        @current-change="currentChange1"
      ></el-pagination>
    </el-dialog>
    <!-- 专栏的弹窗 -->
    <el-dialog
      :title="`添加${goodsType}`"
      :visible.sync="addGoodsListVisible"
      width="900px"
      left
    >
      <el-form
        ref="searchGoodsForm"
        :model="goodsSearchForm"
        label-width="formLabelWidths"
      >
        <el-row>
          <el-col :sm="8" :md="8" :lg="8">
            <el-input
              v-model="goodsSearchForm.name"
              placeholder="请输入商品名"
              auto-complete="off"
            ></el-input>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="goodsPageList"
              icon="el-icon-search"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="goodsPage.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
        @selection-change="selecteGoodsItemChange"
      >
        <el-table-column
          show-overflow-tooltip
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="name"
          label="商品名"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="type"
          label="类型"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="subjectCourseName"
          label="所属科目"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="goodsItemCount"
          label="内容"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="createTime"
          label="创建时间"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100]"
        style="margin-top: 20px; text-align: right"
        :total="goodsPage.total"
        :page-size="goodsPage.pageSize"
        :current-page="goodsPage.pageNumber"
        @size-change="goodsSizeChange"
        @current-change="goodsCurrentChange"
      ></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addGoodsListVisible = false">取 消</el-button>
        <el-button @click="addGoodsBatchList" type="primary">添 加</el-button>
      </div>
    </el-dialog>

    <!-- 直播 -->
    <el-dialog
      title="添加小鹅通直播"
      :visible.sync="addLiveVisible"
      width="800px"
      left
    >
      <el-form
        ref="searchForm"
        :model="liveSearchForm"
        :label-width="formLabelWidths"
      >
        <el-row>
          <el-col :sm="8" :md="8" :lg="8">
            <el-input
              v-model="liveSearchForm.search_content"
              placeholder="请输入视频名称"
              auto-complete="off"
            ></el-input>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="xiaoETongLivePageList(1)"
              icon="el-icon-search"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="livePage.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
        @selection-change="xiaoETongLiveSelectionChange"
      >
        <el-table-column
          show-overflow-tooltip
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column prop="imgUrl" label="封面">
          <template slot-scope="scope">
            <img width="200px" height="80px" :src="scope.row.imgUrl" />
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="名字"
          width="200"
        ></el-table-column>
        <el-table-column prop="aliveStartAt" label="开始时间"></el-table-column>
        <el-table-column prop="aliveStopAt" label="结束时间"></el-table-column>
        <!--        <el-table-column prop="alive_type" label="直播类型">-->
        <!--          <template slot-scope="scope">-->
        <!--            <span v-if="scope.row.alive_type === 10">横屏直播</span>-->
        <!--            <span v-if="scope.row.alive_type === 11">竖屏直播</span>-->
        <!--            <span v-if="scope.row.alive_type === 12">语音直播</span>-->
        <!--            <span v-if="scope.row.alive_type === 13">录播直播</span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column prop="aliveState" label="直播状态">
          <template slot-scope="scope">
            <span v-if="scope.row.aliveState === 0">未开始</span>
            <span v-if="scope.row.aliveState === 1">直播中</span>
            <span v-if="scope.row.aliveState === 2">已结束</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="liveStreamingParam"
          label="串流码"
          width="100"
        ></el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 50]"
        style="margin-top: 20px; text-align: right"
        :total="livePage.total"
        :page-size="livePage.pageSize"
        :current-page="livePage.pageNumber"
        @size-change="liveSizeChange"
        @current-change="liveCurrentChange"
      ></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addLiveVisible = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch('2')" type="primary"
          >添 加</el-button
        >
      </div>
    </el-dialog>
    <!-- 民生教学计划 -->
    <el-dialog
      title="添加民生教学计划"
      :visible.sync="addMinShengTeachPlanShow"
      width="800px"
      left
    >
      <el-row>
        <el-col :sm="24" :md="12" :lg="8">
          <el-form label="民生产品" prop="type" style="width: 800px">
            民生产品:
            <el-select
              v-model="addMinShengItemForm.productId"
              placeholder="选择民生产品"
              style="width: 350px"
            >
              <el-option
                v-for="(item, index) in minShengProductList"
                :key="index"
                :label="item.name"
                :value="item.id"
                @click.native="getTeachplanListByProductId()"
              ></el-option>
            </el-select>
          </el-form>
        </el-col>
      </el-row>

      <el-row>
        <el-col :sm="24" :md="12" :lg="8">
          <el-form
            label="教学计划"
            prop="type"
            style="width: 800px; padding-top: 20px"
          >
            教学计划:
            <el-select
              v-model="addMinShengItemForm.teachPlanId"
              placeholder="选择民生教学计划"
              style="width: 350px"
            >
              <el-option
                v-for="(item, index) in minShengTeachPlanList"
                :key="index"
                :label="item.teachPlanName + ' : ' + item.areaName"
                :value="item.teachPlanId"
              ></el-option>
            </el-select>
          </el-form>
        </el-col>
      </el-row>

      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addMinShengTeachPlanShow = false">取 消</el-button>
        <el-button @click="addGoodsItemByMinSheng()" type="primary"
          >添 加</el-button
        >
      </div>
    </el-dialog>

    <!-- 民生直播 -->
    <el-dialog
      title="添加民生直播"
      :visible.sync="addLiveVisibleMinSheng"
      width="800px"
      left
    >
      <el-row>
        <el-col :sm="24" :md="12" :lg="8">
          <el-form label="民生产品" prop="type" style="width: 800px">
            民生产品:
            <el-select
              v-model="addMinShengItemForm.productId"
              placeholder="选择民生产品"
              style="width: 350px"
            >
              <el-option
                v-for="(item, index) in minShengProductList"
                :key="index"
                :label="item.name"
                :value="item.id"
                @click.native="getTeachplanListByProductId()"
              ></el-option>
            </el-select>
          </el-form>
        </el-col>
      </el-row>

      <el-row>
        <el-col :sm="24" :md="12" :lg="8">
          <el-form
            label="教学计划"
            prop="type"
            style="width: 800px; padding-top: 20px"
          >
            教学计划:
            <el-select
              v-model="addMinShengItemForm.teachPlanId"
              placeholder="选择民生教学计划"
              style="width: 350px"
            >
              <el-option
                v-for="(item, index) in minShengTeachPlanList"
                :key="index"
                :label="item.teachPlanName + ' : ' + item.areaName"
                :value="item.teachPlanId"
                @click.native="getCourseListByTeachPlanId()"
              ></el-option>
            </el-select>
          </el-form>
        </el-col>
      </el-row>

      <el-row>
        <el-col :sm="24" :md="12" :lg="8">
          <el-form
            label="课程模块"
            prop="type"
            style="width: 800px; padding-top: 20px"
          >
            课程模块:
            <el-select
              v-model="addMinShengItemForm.courseId"
              placeholder="选择民生课程模块"
              style="width: 350px"
            >
              <el-option
                v-for="(item, index) in minShengCourseList"
                :key="index"
                :label="item.subjectName + ' : ' + item.courseName"
                :value="item.courseId"
                @click.native="getPeriodListByCourseId()"
              ></el-option>
            </el-select>
          </el-form>
        </el-col>
      </el-row>

      <el-row>
        <el-col :sm="24" :md="12" :lg="8">
          <el-form
            label="课程模块"
            prop="type"
            style="width: 800px; padding-top: 20px"
          >
            直播轮次:
          </el-form>
        </el-col>
        <el-table
          ref="multipleTable"
          :data="minShengPeriodList"
          tooltip-effect="dark"
          style="margin-top: 20px; width: 100%"
          border
          @selection-change="selectionPeriod"
        >
          <el-table-column
            show-overflow-tooltip
            type="selection"
            width="55"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="beginTime"
            label="开始时间"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="endTime"
            label="结束时间"
          ></el-table-column>
          <el-table-column prop="periodName" label="轮次名称"></el-table-column>
          <el-table-column prop="type" label="轮次类型">
            <template slot-scope="scope">
              <span v-if="scope.row.type === 1">直播/回放</span>
              <span v-if="scope.row.type === 2">录播</span>
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addLiveVisibleMinSheng = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch()" type="primary">添 加</el-button>
      </div>
    </el-dialog>

    <!-- 必过资源 -->
    <el-dialog
      title="添加必过资源"
      :visible.sync="biguoVisible"
      width="800px"
      left
    >
      <el-form
        ref="biguoSearchForm"
        :model="biguoSearchForm"
        :label-width="formLabelWidths"
      >
        <el-row>
          <el-col :sm="8" :md="8" :lg="8">
            <el-input
              v-model="biguoSearchForm.keywords"
              placeholder="请输入课程名称"
              auto-complete="off"
            ></el-input>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="getBiGuoProductList"
              icon="el-icon-search"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="biguoList.list"
        tooltip-effect="dark"
        max-height="500"
        style="width: 100%; margin-top: 20px"
        border
        @selection-change="handleBiGuoSelectionChange"
      >
        <el-table-column
          show-overflow-tooltip
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column type="index" label="序号"> </el-table-column>
        <el-table-column prop="image" label="封面" width="120">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.image"
              style="width: 80px; height: 80px"
            />
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          show-overflow-tooltip
          prop="province"
          label="地区"
        ></el-table-column>
        <el-table-column
          width="100"
          show-overflow-tooltip
          prop="special"
          label="课程性质"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="name"
          label="课程名称"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 50, 100, 200]"
        style="margin-top: 20px; text-align: right"
        :total="biguoList.total"
        :page-size="biguoSearchForm.pageSize"
        :current-page="biguoSearchForm.page"
        @size-change="biguoSizeChange"
        @current-change="biguoCurrentChange"
      ></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="biguoVisible = false">取 消</el-button>
        <el-button @click="addBiGuoGoodsItemBatch" type="primary"
          >添 加</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import conmon from "../videoCourse/conmon";
import LiveComponent from "./liveComponent.vue";

export default {
  components: {
    draggable,
    LiveComponent,
    conmon,
  },
  data() {
    return {
      biguoSearchForm: {
        page: 1,
        pageSize: 10,
        keywords: "",
      },
      biguoList: {
        list: [],
        total: 0,
        page: 1,
      },
      multipleBiGuoSelection: [],
      biguoVisible: false,
      addGoodsListVisible: false,
      goodsSearchForm: {},
      goodsPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      goodsType: "",
      treeLoading: false,
      treeList: [],

      showState: 0,
      queryData: {},
      powerList: [],
      checkList: [],
      isPrpover: false,
      videoDialog: false,
      bindVisible: false,
      comMonid: "",
      typeName: "",

      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", //url地址
          },
        ],
        poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      pList: [], //二级列表
      ppList: [], //一级列表
      videoCourseIds: [],
      subjectTreeList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
      page1: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      videocoursePage: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      livePage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      subjectPage: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      chapterPage: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        level: 2,
        sortName: "",
        sortOrder: "",
      },
      actualOperationPage: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      actualOperationForm: {},
      addVideoVisible: false,
      addLiveVisible: false,
      addLiveVisibleMinSheng: false,
      addMinShengTeachPlanShow: false,
      minShengProductList: [], //民生产品
      addMinShengItemForm: {
        productId: "",
        teachPlanId: "",
        courseId: "",
        periodId: "",
      },
      minShengTeachPlanList: [], //民生产品下教学计划
      minShengCourseList: [], //教学计划下课程模块
      minShengPeriodList: [], //课程模块下轮次列表
      addSubjectVisible: false,
      addChapterVisible: false,
      addActualOperationVisible: false,
      searchForm: {},
      videoSearchForm: {},
      liveSearchForm: {},
      subjectForm: {},
      chapterForm: {
        ppid: "",
        pid: "",
      },
      formLabelWidth: "80px",
      formLabelWidths: "100px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/goodsItem/upload`,

      fileList: [],
      loading: true,
      goodsItemIdData: [],
      type: "",
      chapterListType: "",
      teacherIds: [],
      teacherProps: {
        value: "id",
        label: "name",
      },
      teacherList: [],
      // liveForm: {
      //   liveType: "",
      //   liveName: "",
      //   liveTeacherName: "",
      //   liveTeacherImgUrl: "",
      //   liveBeginTime: "",
      //   liveEndTime: "",
      //   time: [],
      //   // 小鹅通
      //   liveStreamingParam: "",
      // },
      // liveRules: {
      //   liveName: [
      //     { required: true, message: "请输入直播名称", trigger: "blur" },
      //   ],
      //   liveTeacherName: [
      //     { required: true, message: "请输入老师名称", trigger: "blur" },
      //   ],
      //   liveTeacherImgUrl: [
      //     { required: true, message: "请上传老师头像", trigger: "change" },
      //   ],
      //   time: [
      //     { required: true, message: "请选择直播时间", trigger: "change" },
      //   ],
      //   liveStreamingParam: [
      //     { required: true, message: "请输入直播串流码", trigger: "blur" },
      //   ],
      // },
      // fileObj: {
      //   url: process.env.BASE_URL + "/system/uploadFile",
      // },
      // liveType: 1,
      // liveTypeName:'保利威',
      // isEdit:false,
      hasLiveRoom: false,
    };
  },

  computed: {
    reqData() {
      return this.$store.state.user;
    },
  },
  methods: {
    // zhibo
    // openLiveDialog(type) {
    //   this.liveType = type;
    //   this.liveTypeName = type == 1 ? '保利威' : type == 2 ? '小鹅通' : '民生'
    //   this.addLiveVisible = true;
    //   this.isEdit = false

    //   this.liveForm = {
    //     liveType: "",
    //     liveName: "",
    //     liveTeacherName: "",
    //     liveTeacherImgUrl: "",
    //     liveBeginTime: "",
    //     liveEndTime: "",
    //     time: [],
    //     liveStreamingParam: "",
    //   }
    // },
    // // 上传
    // UploadSuccess(res, file, fileList, val) {
    //   this.liveForm.liveTeacherImgUrl = res.data;
    // },
    // beforeUpload(file) {
    //   const isJPG = file.type.indexOf("image") > -1;
    //   const isLt2M = file.size / 1024 / 1024 < 2;
    //   if (!isJPG) {
    //     this.$message.error("上传文件必须是图片哦!");
    //   }
    //   if (!isLt2M) {
    //     this.$message.error("上传图片大小不能超过 2MB!");
    //   }
    //   return isJPG && isLt2M;
    // },
    // // 时间
    // timeChange(e) {
    //   this.liveForm.liveBeginTime = e[0];
    //   this.liveForm.liveEndTime = e[1];
    // },
    // handleCloseLiveDialog() {
    //   this.addLiveVisible = false;
    //   this.$refs.liveForm.resetFields();
    // },
    // addLiveItem() {
    //   this.$refs.liveForm.validate((valid) => {
    //     if (valid) {
    //       if(!this.isEdit){
    //         let body = Object.assign({}, {goodsId:this.$route.query.goodsId,type:'直播'}, this.liveForm);
    //         body.liveType = this.liveType;
    //         delete body.time;
    //         let params = {goodsId: this.$route.query.goodsId, addWay: this.$route.query.addWay}
    //         this.api.live.addGoodsItemBatch([body],params).then(res=>{
    //           if(res.code == 200 && res.success){
    //             this.pageList()
    //           }
    //         }).finally(()=>{this.handleCloseLiveDialog()});
    //       }else{

    //       }
    //     }
    //   });

    //   console.log(this.liveForm, 432343);
    // },
    // editLive(item){
    //   this.liveType = item.liveType
    //   this.liveTypeName = item.liveType == 1 ? '保利威' : item.liveType == 2 ? '小鹅通' : '民生'
    //   this.liveForm = JSON.parse(JSON.stringify(item));
    //   this.liveForm.time = [this.liveForm.liveBeginTime,this.liveForm.liveEndTime]
    //   this.isEdit = true
    //   this.addLiveVisible = true;
    // },
    // =====================================================================
    // 范围弹出窗赋初值
    rangeCli(form) {
      this.checkList = [];
      this.powerList = JSON.parse(JSON.stringify(form.powerList));
      form.powerList.forEach((item) => {
        if (item.hasPower) this.checkList.push(item.power);
      });
    },
    // 范围更改提交
    sunmitType(element) {
      let val = 0;
      this.checkList.forEach((item) => (val = val | +item));
      let obj = JSON.parse(JSON.stringify(element));
      obj.power = val;
      // console.log(obj);
      this.api.videoInfo.updateGoodsItem(obj).then((res) => {
        if (res.code == 200) {
          element.isPrpover = false;
          this.$message.success(res.message);
        } else this.$message.error(res.message);
        this.pageList();
      });
    },
    opConmon(row, sty) {
      this.bindVisible = true;
      this.comMonid = sty == 1 ? row.objectId : row.id;
      this.typeName = row.type;
      this.pageList1(row.showState);
    },
    pageList1(rState) {
      this.page1.videoCourseId = this.comMonid;
      this.page1.showState = rState || "";
      this.api.videoInfo
        .pageList(this.page1)
        .then((result) => {
          if (result.success) {
            this.showState = result.data.showState;
            if (this.showState == 0) {
              // 非层级
              this.page1.rows = result.data.pageList.records;
              this.page1.total = result.data.pageList.total;
            } else {
              // 层级
              this.page1.rows = result.data.subjectVideoList;
            }
          } else {
            this.$message.error(result.message);
          }
        })

        .catch((error) => {
          console.log(error);
        });
    },
    closeDialog() {
      this.$refs.videoPlayer.player.pause(); //暂停
    },
    deleteCancel() {
      // alert(0);
    },
    datadragEnd(evt) {
      console.log(evt);
      let arr = [];
      this.page.rows.forEach((item, index) => {
        arr.push({
          id: item.id,
          sort: index + 1,
        });
      });
      console.log(arr);
      this.api
        .changeSort(arr)
        .then((result) => {
          this.$message.success(result.message);
        })
        .catch((error) => {
          console.log(error);
        });
      evt.preventDefault();
      // console.log("拖动前的索引 :" + evt.oldIndex);
      // console.log("拖动后的索引 :" + evt.newIndex);
      // console.log(this.colors);
    },

    // 专栏 start ===================================================================================
    addGoodsList(type) {
      this.goodsSearchForm = {};
      this.type = "专栏";
      this.goodsType = type;
      let params = {
        type,
        pageSize: this.goodsPage.pageSize,
        pageNumber: this.goodsPage.pageNumber,
      };
      console.log(params, 34);
      this.getGoodsInfo(params);
      this.addGoodsListVisible = true;
    },
    // 获取录播课程
    getGoodsInfo(params) {
      this.api.subjectCourse.getGoodsInfoCenterByType(params).then((res) => {
        if (res.success) {
          let { data } = res;
          this.goodsPage.rows = data.records;
          this.goodsPage.total = data.total;
          console.log(this.goodsPage.rows);
        }
      });
    },
    // 专栏弹窗中的search方法
    goodsPageList() {
      let name = this.goodsSearchForm.name;
      let params = {
        name,
        type: this.goodsType,
        pageSize: this.goodsPage.pageSize,
        pageNumber: this.goodsPage.pageNumber,
      };
      this.getGoodsInfo(params);
    },
    // 专栏弹窗中的添加方法
    addGoodsBatchList() {
      console.log(this.ids);
      this.api.goodsItem
        .addGoodsItemBatch(this.ids, {
          goodsId: this.$route.query.goodsId,
          addWay: this.$route.query.addWay,
        })
        .then((result) => {
          if (result.success) {
            this.addGoodsListVisible = false;
            this.$message.success(result.message);
            this.pageList();
            this.ids = [];
          } else {
            this.$message(result.message);
          }
        });
    },
    // 分页 -- 每页条数
    goodsSizeChange(pageSize) {
      console.log(pageSize);
      this.goodsPage.pageSize = pageSize;
      this.addGoodsList(this.goodsType);
    },
    // 分页 -- 页数
    goodsCurrentChange(pageNumber) {
      console.log(pageNumber, this.goodsType);
      this.goodsPage.pageNumber = pageNumber;
      this.addGoodsList(this.goodsType);
    },
    // 批量选择
    selecteGoodsItemChange(val) {
      this.multipleSelection = val;
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.id,
        type: this.type,
      }));
    },
    // 专栏 end =====================================================================================

    addGoodsVideo() {
      this.type = "录播课程";
      this.getSubjectTreeList();
      this.videocoursePageList();
      this.addVideoVisible = true;
    },
    addMinShengTeachPlan() {
      this.minShengProductList = [];
      this.type = "民生教学计划";
      this.api.minShengCourseInfo
        .getProductList({})
        .then((result) => {
          this.minShengProductList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.addMinShengTeachPlanShow = true;
    },
    getTeachplanListByProductId() {
      if (this.addMinShengItemForm.productId == "") {
        this.$message.error("请先选择产品");
        return;
      }
      let param = {
        productId: this.addMinShengItemForm.productId,
      };
      this.api.minShengCourseInfo
        .getTeachplanListByProductId(param)
        .then((result) => {
          this.minShengTeachPlanList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCourseListByTeachPlanId() {
      if (this.addMinShengItemForm.teachPlanId == "") {
        this.$message.error("请先选择教学计划");
        return;
      }
      let param = {
        teachPlanId: this.addMinShengItemForm.teachPlanId,
      };
      this.api.minShengCourseInfo
        .getCourseListByTeachPlanId(param)
        .then((result) => {
          this.minShengCourseList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPeriodListByCourseId() {
      if (this.addMinShengItemForm.courseId == "") {
        this.$message.error("请先选择课程模块");
        return;
      }
      let param = {
        courseId: this.addMinShengItemForm.courseId,
        teachPlanId: this.addMinShengItemForm.teachPlanId,
      };
      this.api.minShengCourseInfo
        .getPeriodListByCourseId(param)
        .then((result) => {
          this.minShengPeriodList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addLiveVideo(liveType) {
      this.type = "直播课程";
      if (liveType == 2) {
        //小鹅通直播
        this.xiaoETongLivePageList();
        this.addLiveVisible = true;
      } else if (liveType == 1) {
        //民生直播
        this.minShengPeriodList = [];
        this.minShengTeachPlanList = [];
        this.minShengCourseList = [];
        this.minShengProductList = [];
        this.api.minShengCourseInfo
          .getProductList({})
          .then((result) => {
            this.minShengProductList = result.data;
          })
          .catch((error) => {
            console.log(error);
          });
        this.addLiveVisibleMinSheng = true;
      }
    },
    addGoodsSubject() {
      this.type = "试卷";
      this.getSubjectTreeList();
      this.pageListExamType();
      this.addSubjectVisible = true;
    },
    addGoodsChapter(chapterListType) {
      if (chapterListType == "直播") {
        this.addLiveVisible = true;
      } else {
        // this.type = "章节";
        this.chapterListType = chapterListType;
        this.type = chapterListType + "课程";
        this.getTypeLit();
        this.pageListChapter();
        this.addChapterVisible = true;
      }
    },
    addGoodsActualOperation() {
      this.type = "实训课程";
      this.pageListActualOperation();
      this.addActualOperationVisible = true;
    },
    videoSubjectChange(val) {
      this.videoSearchForm.courseIds = [];
      val.forEach((item) => {
        this.videoSearchForm.courseIds.push(item[2]);
      });
    },
    subjectChange(val) {
      this.subjectForm.ids = [];
      val.forEach((item) => {
        this.subjectForm.ids.push(item[2]);
      });
    },
    videocoursePageList() {
      this.videoSearchForm.pageSize = this.videocoursePage.pageSize;
      this.videoSearchForm.pageNumber = this.videocoursePage.pageNumber;
      this.videoSearchForm.sortName = this.videocoursePage.sortName;
      this.videoSearchForm.sortOrder = this.videocoursePage.sortOrder;
      this.videoSearchForm.subjectId = this.$route.query.subjectId;
      this.videoSearchForm.type =
        this.goodsItemIdData.type == "直播" ||
        this.goodsItemIdData.type == "录播"
          ? this.goodsItemIdData.type
          : "";

      this.api.videoCourse
        .pageList(this.videoSearchForm)
        .then((result) => {
          this.videocoursePage.rows = result.data.records;
          this.videocoursePage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    livePageList() {
      this.liveSearchForm.subjectId = this.$route.query.subjectId;
      this.liveSearchForm.pageSize = this.livePage.pageSize;
      this.liveSearchForm.pageNumber = this.livePage.pageNumber;
      this.liveSearchForm.sortName = this.livePage.sortName;
      this.liveSearchForm.sortOrder = this.livePage.sortOrder;
      this.liveSearchForm.type = "1";
      this.api.liveRoom
        .pageList(this.liveSearchForm)
        .then((result) => {
          this.livePage.rows = result.data.records;
          this.livePage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageListExamType() {
      this.subjectForm.pageSize = this.subjectPage.pageSize;
      this.subjectForm.pageNumber = this.subjectPage.pageNumber;
      this.subjectForm.sortName = this.subjectPage.sortName;
      this.subjectForm.sortOrder = this.subjectPage.sortOrder;
      this.api.goodsItem
        .pageListExamType(this.subjectForm)
        .then((result) => {
          this.subjectPage.rows = result.data.records;
          this.subjectPage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageListChapter() {
      this.chapterForm.pageSize = this.chapterPage.pageSize;
      this.chapterForm.pageNumber = this.chapterPage.pageNumber;
      this.chapterForm.level = this.chapterPage.level;
      this.chapterForm.sortName = this.chapterPage.sortName;
      this.chapterForm.sortOrder = this.chapterPage.sortOrder;
      this.chapterForm.pid = this.$route.query.subjectId;

      this.api.subjectCourse
        .getPageList(this.chapterForm)
        .then((result) => {
          this.chapterPage.rows = result.data.records;
          this.chapterPage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageListActualOperation() {
      this.actualOperationForm.pageSize = this.actualOperationPage.pageSize;
      this.actualOperationForm.pageNumber = this.actualOperationPage.pageNumber;
      this.actualOperationForm.sortName = this.actualOperationPage.sortName;
      this.actualOperationForm.sortOrder = this.actualOperationPage.sortOrder;
      this.api.goodsItem
        .actualOperationPageList(this.actualOperationForm)
        .then((result) => {
          this.actualOperationPage.rows = result.data.records;
          this.actualOperationPage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    xiaoETongLivePageList(page) {
      this.loading = true;
      this.liveSearchForm.page_size = this.livePage.pageSize;
      this.liveSearchForm.page = this.livePage.pageNumber;
      if (page != null) {
        this.liveSearchForm.page = page;
      }
      if (this.liveSearchForm.page_size > 50) {
        this.$message.error("每页最大数量50条!");
      }
      this.api.xiaoETongLiveInfo
        .pageList(this.liveSearchForm)
        .then((result) => {
          this.loading = false;
          this.livePage.rows = result.data.data.list;
          this.livePage.total = result.data.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    addGoodsItemBatch() {
      // console.log(JSON.stringify(this.ids))
      this.api.goodsItem
        .addGoodsItemBatch(this.ids, {
          goodsId: this.$route.query.goodsId,
          addWay: this.$route.query.addWay,
        })
        .then((result) => {
          if (result.success) {
            this.addVideoVisible = false;
            this.addSubjectVisible = false;
            this.addChapterVisible = false;
            this.addLiveVisible = false;
            this.addActualOperationVisible = false;
            this.pageList();
            this.$message.success(result.message);
            this.ids = [];
            this.addMinShengItemForm = {
              productId: "",
              teachPlanId: "",
              courseId: "",
              periodId: "",
            };
            this.addLiveVisibleMinSheng = false;
          } else {
            this.$message(result.message);
          }
        });
    },
    //民生教学计划资源
    addGoodsItemByMinSheng() {
      let param = [
        {
          objectId: this.addMinShengItemForm.teachPlanId,
          goodsId: this.$route.query.goodsId,
          type: "民生教学计划",
          liveTeachPlanIdByMinS: this.addMinShengItemForm.teachPlanId,
          liveProductIdByMinS: this.addMinShengItemForm.productId,
        },
      ];
      this.api.goodsItem
        .addGoodsItemBatch(param, {
          goodsId: this.$route.query.goodsId,
          addWay: this.$route.query.addWay,
        })
        .then((result) => {
          if (result.success) {
            this.addVideoVisible = false;
            this.addSubjectVisible = false;
            this.addChapterVisible = false;
            this.addLiveVisible = false;
            this.addActualOperationVisible = false;
            this.addMinShengTeachPlanShow = false;
            this.addMinShengItemForm = {
              productId: "",
              teachPlanId: "",
            };
            this.pageList();
            this.$message.success(result.message);
            this.ids = [];
          } else {
            this.$message(result.message);
          }
        });
    },
    deleteGoodsItem(vId) {
      this.api.goodsItem.deleteGoodsItem([{ id: vId }]).then((result) => {
        if (result.success) {
          this.pageList();
          this.$message.success("解绑成功");
        } else {
          this.$message(result.message);
        }
      });
    },
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取一级列表
    getTypeLit() {
      this.api.subjectCourse
        .getSubjectCourseListByPid({
          pid: 0,
        })
        .then((result) => {
          this.ppList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //获取二级列表
    choosePPid() {
      this.api.subjectCourse
        .getSubjectCourseListByPid({
          pid: this.chapterForm.ppid,
        })
        .then((result) => {
          this.pList = result.data;
          this.chapterForm.pid = "";
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getGoodsItemData() {
      this.api.goodsInfo
        .getGoodsInfo({ id: this.$route.query.updatePageGoodsItem })
        .then((result) => {
          this.goodsItemIdData = result.data;
          console.log("this..goodsItemdata", this.goodsItemIdData);
          this.pageList();
        });
      console.log(this.goodsItemIdData, 44);
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    sizeChange1(pageSize) {
      this.page1.pageSize = pageSize;
      this.pageList1();
    },
    currentChange1(pageNumber) {
      this.page1.pageNumber = pageNumber;
      this.pageList1();
    },

    videoSizeChange(pageSize) {
      this.videocoursePage.pageSize = pageSize;
      this.videocoursePageList();
    },
    videoCurrentChange(pageNumber) {
      this.videocoursePage.pageNumber = pageNumber;
      this.videocoursePageList();
    },
    liveSizeChange(pageSize) {
      this.livePage.pageSize = pageSize;
      this.xiaoETongLivePageList();
    },
    liveCurrentChange(pageNumber) {
      this.livePage.pageNumber = pageNumber;
      this.xiaoETongLivePageList();
    },
    subjectSizeChange(pageSize) {
      this.subjectPage.pageSize = pageSize;
      this.pageListExamType();
    },
    subjectCurrentChange(pageNumber) {
      this.subjectPage.pageNumber = pageNumber;
      this.pageListExamType();
    },
    chapterSizeChange(pageSize) {
      this.chapterPage.pageSize = pageSize;
      this.pageListChapter();
    },
    chapterCurrentChange(pageNumber) {
      this.chapterPage.pageNumber = pageNumber;
      this.pageListChapter();
    },
    actualOperationSizeChange(pageSize) {
      this.actualOperationPage.pageSize = pageSize;
      this.pageListActualOperation();
    },
    actualOperationCurrentChange(pageNumber) {
      this.actualOperationPage.pageNumber = pageNumber;
      this.pageListActualOperation();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.id,
        type: this.type,
      }));
    },
    selectionPeriod(val) {
      this.multipleSelection = val;
      this.ids = val.map((e) => ({
        objectId: this.addMinShengItemForm.teachPlanId,
        goodsId: this.$route.query.goodsId,
        type: this.type,
        liveType: 3,
        liveTeachPlanIdByMinS: this.addMinShengItemForm.teachPlanId,
        liveProductIdByMinS: this.addMinShengItemForm.productId,
        liveCourseIdByMinS: this.addMinShengItemForm.courseId,
        livePeriodIdByMinS: e.periodId,
      }));
    },
    xiaoETongLiveSelectionChange(val) {
      this.ids = val.map((e) => ({
        objectId: e.newId,
        goodsId: this.goodsItemIdData.id,
        type: this.type,
        liveType: 2,
      }));
    },
    subjectSelectionChange(val) {
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.id,
        type: this.type,
        examType: e.examType,
      }));
    },
    chapterSelectionChange(val) {
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.id,
        type: this.type,
      }));
    },
    actualOperationChange(val) {
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.id,
        type: this.type,
      }));
    },
    pageList() {
      console.log(this.goodsItemIdData, 2345);
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.goodsId = this.goodsItemIdData.id;
      this.searchForm.type =
        this.goodsItemIdData.type == "直播" ? "直播" : undefined;
      this.api.goodsItem
        .pageList(this.searchForm)
        .then((result) => {
          console.log(this.goodsItemIdData, 23456);
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          if (this.goodsItemIdData.type == "直播" && this.page.total > 0) {
            this.hasLiveRoom = true;
          } else {
            this.hasLiveRoom = false;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 必过----------------------------------
    addBiGuo() {
      this.biguoVisible = true;
      this.biguoSearchForm = { page: 1, pageSize: 10, keywords: "" };
      this.getBiGuoProductList();
    },
    getBiGuoProductList() {
      this.api.goodsInfo
        .getBiGuoProductList(this.biguoSearchForm)
        .then((res) => {
          this.biguoList = res.data;
        });
    },
    biguoSizeChange(pageSize) {
      this.biguoSearchForm.pageSize = pageSize;
      this.getBiGuoProductList();
    },
    biguoCurrentChange(pageNumber) {
      this.biguoSearchForm.page = pageNumber;
      this.getBiGuoProductList();
    },
    handleBiGuoSelectionChange(e) {
      this.multipleBiGuoSelection = e;
    },
    addBiGuoGoodsItemBatch() {
      let param = this.multipleBiGuoSelection.map((item) => {
        return {
          type: "必过资源",
          productIdByBiGuo: item.productId,
          goodsId: this.$route.query.goodsId,
          liveName: item.name,
        };
      });
      this.api.goodsItem
        .addGoodsItemBatch(param, {
          goodsId: this.$route.query.goodsId,
          addWay: this.$route.query.addWay,
        })
        .then((result) => {
          if (result.success) {
            this.biguoVisible = false;
            this.biguoList = {};
            this.biguoSearchForm = { page: 1, pageSize: 10, keywords: "" };
            this.pageList();
            this.$message.success(result.message);
            this.ids = [];
          } else {
            this.$message(result.message);
          }
        });
    },
    // ----------------------------------必过
  },
  mounted() {
    this.getGoodsItemData();
    this.queryData = this.$route.query;
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-table__expanded-cell {
  padding: 20px 50px;
}
.type-btn {
  transform: translateX(-50%);
  margin-left: 50%;
  margin-top: 15px;
}
.line {
  display: inline-block;
  margin: 0 5px;
  border-left: 1px solid #a39e9e75;
  height: 10px;
}
.draggable-tableaaa {
  margin-top: 20px;
  border-top: 1px solid #d9ebf5;
  border-left: 1px solid #d9ebf5;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  .bor {
    font-weight: bolder;
    color: #4e4e4e;
    background-color: rgb(250, 250, 250) !important;
  }
  .draggable-table {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    div {
      padding: 8px 10px;
      font-size: 12px;
      line-height: 23px;
    }
    .htmltittles {
      white-space: nowrap;
      padding: 0px;
      overflow: hidden;
      text-overflow: ellipsis;
      img {
        display: none !important;
      }
      p {
        font-size: 12px !important;
        line-height: 23px !important;
        margin: 0px !important;
        color: #606266 !important;
        white-space: nowrap !important;
        img {
          display: none !important;
        }
      }
    }
    .title {
      width: 60%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .state {
        padding: 0;
        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }
      .questionTypeName {
        padding: 0;

        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }
      white-space: nowrap;
    }
    .answer {
      width: 22%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .delete {
      width: 12%;
      cursor: pointer;
      border-bottom: 1px solid #d9ebf5;
      text-align: center;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.avatar-uploader-logo {
  margin-right: 30px;
  .avatar {
    width: 56px;
    height: 56px;
    line-height: 56px;
    text-align: center;
    border-radius: 50%;
    background-color: #f8f8f8;
    border: 1px dashed #333;
  }
}
.editPointC {
  display: flex;
  align-items: flex-end;
}
.paySetting-tips {
  font-size: 12px;
  color: #4e4e4e;
}
</style>



// WEBPACK FOOTER //
// src/components/goods/goodsItem.vue